/**
 * Aussie Betta Share & Earn — Referral Widget
 * Floating CTA for referral users redirected from the S&E dashboard.
 * Detects ab_se=1 + ab_campaign=<slug>, waits 5s, shows responsive floating card.
 * Dismiss state is scoped per campaign.
 */

(function () {
  'use strict';

  var SESSION_KEY = 'ab_referral_detected';
  var SESSION_CAMPAIGN_KEY = 'ab_referral_campaign';
  var DISMISSED_PREFIX = 'ab_share_widget_dismissed:';
  var DELAY_MS = 5000;
  var ANIM_MS = 400;

  function detect() {
    var params = new URLSearchParams(window.location.search);
    var se = params.get('ab_se');
    var campaign = params.get('ab_campaign');
    if (se === '1' && campaign) {
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
        sessionStorage.setItem(SESSION_CAMPAIGN_KEY, campaign);
      } catch (_) {}
      var url = new URL(window.location.href);
      url.searchParams.delete('ab_se');
      url.searchParams.delete('ab_campaign');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
      return campaign;
    }
    try {
      if (sessionStorage.getItem(SESSION_KEY) === '1') {
        return sessionStorage.getItem(SESSION_CAMPAIGN_KEY) || null;
      }
    } catch (_) {}
    return null;
  }

  function isDismissed(campaign) {
    try {
      return localStorage.getItem(DISMISSED_PREFIX + campaign) === '1';
    } catch (_) { return false; }
  }

  function setDismissed(campaign) {
    try { localStorage.setItem(DISMISSED_PREFIX + campaign, '1'); } catch (_) {}
  }

  function clearSessionFlags() {
    try {
      sessionStorage.removeItem(SESSION_KEY);
      sessionStorage.removeItem(SESSION_CAMPAIGN_KEY);
    } catch (_) {}
  }

  var MOBILE_MQ = '(max-width: 749px)';
  var MOBILE_GAP_PX = 14;

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function stickyBarRect() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return null;
    var cs = window.getComputedStyle(bar);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return null;
    var r = bar.getBoundingClientRect();
    return (r.width > 0 && r.height > 0) ? r : null;
  }

  function chatRect() {
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (!root) return null;
    var found = null;
    root.querySelectorAll('*').forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.width > 30 && r.width < 200 && r.height > 30 && r.height < 200) found = r;
    });
    return found;
  }

  function rectsIntersect(a, b) {
    return !(a.right <= b.left || b.right <= a.left || a.bottom <= b.top || b.bottom <= a.top);
  }

  // Mobile only: sit above the theme's fixed purchase bar and keep clear of the Inbox bubble.
  function layoutWidget(el) {
    if (!isMobile()) {
      el.style.left = '';
      el.style.right = '';
      el.style.bottom = '';
      return;
    }
    var bar = stickyBarRect();
    var bottom = (bar ? Math.round(bar.height) : 0) + MOBILE_GAP_PX;
    el.style.left = '16px';
    el.style.right = 'auto';
    el.style.bottom = 'calc(' + bottom + 'px + env(safe-area-inset-bottom, 0px))';
    var chat = chatRect();
    if (chat && rectsIntersect(el.getBoundingClientRect(), chat)) {
      bottom += Math.round(chat.height) + 8;
      el.style.bottom = 'calc(' + bottom + 'px + env(safe-area-inset-bottom, 0px))';
    }
  }

  function watchLayout(el) {
    var ticking = false;
    var relayout = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (el.parentNode) layoutWidget(el);
      });
    };
    window.addEventListener('scroll', relayout, { passive: true });
    window.addEventListener('resize', relayout);
    window.addEventListener('orientationchange', relayout);
    // The theme flips data-stuck asynchronously after scrolling stops; scroll events alone miss it.
    // The bar then fades over ~300ms, so re-measure once more after the fade settles.
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar && window.MutationObserver) {
      new window.MutationObserver(function () {
        relayout();
        window.setTimeout(relayout, 450);
      }).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    }
    var checks = 0;
    var iv = window.setInterval(function () {
      checks += 1;
      relayout();
      if (checks >= 10 || !el.parentNode) window.clearInterval(iv);
    }, 1000);
  }

  function createWidget(campaign) {
    var el = document.createElement('div');
    el.id = 'ab-se-widget';
    el.setAttribute('role', 'complementary');
    el.setAttribute('aria-label', 'Share and Earn');

    el.innerHTML =
      '<div id="ab-se-widget-inner">' +
        '<button id="ab-se-widget-close" type="button" aria-label="Close">&times;</button>' +
        '<p id="ab-se-widget-title">\uD83C\uDF81 Enjoying Aussie Betta?</p>' +
        '<p id="ab-se-widget-body">Share with friends and earn Store Credit.</p>' +
        '<a id="ab-se-widget-cta" href="https://share.aussiebetta.com/dashboard">Share &amp; Earn</a>' +
      '</div>';

    var style = document.createElement('style');
    style.textContent =
      '#ab-se-widget{' +
        'position:fixed;z-index:999999;' +
        'bottom:20px;left:20px;' +
        'opacity:0;transform:translateX(-20px);' +
        'transition:opacity ' + ANIM_MS + 'ms ease,transform ' + ANIM_MS + 'ms ease;' +
        'pointer-events:none;' +
      '}' +
      '#ab-se-widget.ab-se-visible{opacity:1;transform:translateX(0);pointer-events:auto;}' +
      '#ab-se-widget-inner{' +
        'background:#fff;border-radius:12px;box-shadow:0 4px 24px rgba(0,0,0,.15);' +
        'padding:20px 24px 18px;max-width:280px;position:relative;' +
        'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;' +
      '}' +
      '#ab-se-widget-close{' +
        'position:absolute;top:6px;right:10px;background:none;border:none;' +
        'font-size:20px;line-height:1;cursor:pointer;color:#999;padding:4px;' +
      '}' +
      '#ab-se-widget-close:hover{color:#333;}' +
      '#ab-se-widget-title{margin:0 0 6px;font-size:15px;font-weight:600;color:#1a1a1a;}' +
      '#ab-se-widget-body{margin:0 0 14px;font-size:13px;color:#555;line-height:1.4;}' +
      '#ab-se-widget-cta{' +
        'display:inline-block;background:#3a5a40;color:#fff;text-decoration:none;' +
        'border-radius:8px;padding:8px 18px;font-size:13px;font-weight:600;' +
        'transition:background .2s ease;' +
      '}' +
      '#ab-se-widget-cta:hover{background:#2d4a34;}' +
      '@media(max-width:749px){' +
        '#ab-se-widget{' +
          'left:16px;right:auto;bottom:16px;' +
          'transform:translateY(16px);' +
        '}' +
        '#ab-se-widget.ab-se-visible{transform:translateY(0);}' +
        '#ab-se-widget-inner{' +
          'display:flex;align-items:center;overflow:hidden;' +
          'max-width:calc(100vw - 32px);padding:0;text-align:left;' +
          'background:rgba(255,252,246,.9);' +
          '-webkit-backdrop-filter:blur(10px) saturate(140%);' +
          'backdrop-filter:blur(10px) saturate(140%);' +
          'border:1px solid rgba(58,90,64,.16);border-radius:999px;' +
          'box-shadow:0 6px 20px rgba(31,41,32,.16);' +
        '}' +
        '#ab-se-widget.ab-se-visible #ab-se-widget-inner{' +
          'animation:ab-se-pill-pulse 900ms ease-out 1;' +
        '}' +
        '@keyframes ab-se-pill-pulse{' +
          '0%{box-shadow:0 6px 20px rgba(31,41,32,.16),0 0 0 0 rgba(58,90,64,.30);}' +
          '70%{box-shadow:0 6px 20px rgba(31,41,32,.16),0 0 0 10px rgba(58,90,64,0);}' +
          '100%{box-shadow:0 6px 20px rgba(31,41,32,.16),0 0 0 0 rgba(58,90,64,0);}' +
        '}' +
        '#ab-se-widget-title,#ab-se-widget-body{display:none;}' +
        '#ab-se-widget-cta{' +
          'display:flex;align-items:center;flex:1 1 auto;white-space:nowrap;order:1;' +
          'background:transparent;color:#2d4a34;border-radius:0;' +
          'padding:13px 10px 13px 16px;font-size:14px;line-height:18px;' +
        '}' +
        '#ab-se-widget-cta::before{content:"\uD83C\uDF81";margin-right:7px;font-size:15px;}' +
        '#ab-se-widget-cta:hover{background:transparent;}' +
        '#ab-se-widget-close{' +
          'position:static;flex:0 0 auto;order:2;padding:13px 14px 13px 4px;' +
          'font-size:18px;color:#8b8b86;' +
        '}' +
        '#ab-se-widget-close:hover{color:#555;}' +
      '}';

    document.head.appendChild(style);
    document.body.appendChild(el);
    layoutWidget(el);
    watchLayout(el);

    var closeBtn = el.querySelector('#ab-se-widget-close');
    closeBtn.addEventListener('click', function () {
      el.classList.remove('ab-se-visible');
      setDismissed(campaign);
      clearSessionFlags();
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, ANIM_MS);
    });

    return el;
  }

  function run() {
    var campaign = detect();
    if (!campaign) return;
    if (isDismissed(campaign)) return;

    setTimeout(function () {
      var widget = createWidget(campaign);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          widget.classList.add('ab-se-visible');
        });
      });
    }, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
